module.exports = __webpack_public_path__ + "img/iron1.3e3d3223.png";